// src/constants.ts
   // export const baseUrl = "http://localhost:3000/api";
// export const baseUrl = "https://teams-management-backend-1.onrender.com/api";
export const baseUrl = "https://alseirafi-group.com/api";

// WebSocket origin (NO /api)
export const wsUrl = "https://alseirafi-group.com";

//  export const wsUrl = "http://localhost:3002";
// For Render/prod: export const wsUrl = "https://teams-management-backend-1.onrender.com";